import React from 'react';
import { routes } from './routes.constatns';
import { Navigate, Route } from 'react-router-dom';
import { useEffect } from 'react';
import App from '../App';

const ViewEngagement = React.lazy(() =>
  import('../components/ViewEngagement/ViewEngagement').then(module => ({
    default: module.ViewEngagement,
  }))
);

const ProjectDetails = React.lazy(() =>
  import(
    '../components/ProjectsLibrary/components/ProjectDetails/ProjectDetails'
  ).then(module => ({ default: module.ProjectDetails }))
);

const ProjectsLibrary = React.lazy(() =>
  import('../components/ProjectsLibrary/ProjectsLibrary').then(module => ({
    default: module.ProjectsLibrary,
  }))
);

const CreateNewScenario = React.lazy(() =>
  import(
    '../components/Simulate/components/createNewScenario/CreateNewScenario'
  ).then(module => ({ default: module.CreateNewScenario }))
);

const ExternalUserPowerBI = React.lazy(() =>
  import('../components/PowerBI/ExternalUserPowerBI').then(module => ({
    default: module.ExternalUserPowerBI,
  }))
);

const CreateNewEngagement = React.lazy(() =>
  import('../components').then(module => ({ default: module.CreateNewEngagement }))
);

const Home = React.lazy(() =>
  import('../components').then(module => ({ default: module.Home }))
);

const PowerBI = React.lazy(() =>
  import('../components').then(module => ({ default: module.PowerBI }))
);

const CreateNewProject = React.lazy(() =>
  import('../components').then(module => ({ default: module.CreateNewProject }))
);

const AddGMP = React.lazy(() =>
  import('../components').then(module => ({ default: module.AddGMP }))
);

const AddForecast = React.lazy(() =>
  import('../components').then(module => ({ default: module.AddForecast }))
);

const ImportExcel = React.lazy(() =>
  import('../components').then(module => ({ default: module.ImportExcel }))
);

const AddTarget = React.lazy(() =>
  import('../components').then(module => ({ default: module.AddTarget }))
);

const AddTargetSpecification = React.lazy(() =>
  import('../components').then(module => ({ default: module.AddTargetSpecification }))
);

const AddForecastSpecification = React.lazy(() =>
  import('../components').then(module => ({ default: module.AddForecastSpecification }))
);

const isURLAllowed = process.env.REACT_APP_URL_BASE_ALLOW_HOME_URL === 'true';
const externalUrl = process.env.REACT_APP_URL_REG_ALL;

const RedirectToExternal = () => {
  useEffect(() => {
    window.location.href = externalUrl;
  }, []);

  return null;
};
export const AppRoutes = (
  <Route path={routes.root} element={<App />}>
    {isURLAllowed ? (
      <>
        <Route index element={<Navigate to={`/${routes.home}`} />} />
        <Route path={routes.home} element={<Home />} />
      </>
    ) : (
      <Route path="*" element={<RedirectToExternal />} /> // Redirect to default URL
    )}
    <Route path={routes.createNewEngagement}>
      <Route index element={<CreateNewEngagement />} />
      <Route path={routes.createNewProject} element={<CreateNewProject />} />
      <Route path={routes.addGMP} element={<AddGMP />} />
      <Route path={routes.importExcel} element={<ImportExcel />} />
      <Route path={routes.addTarget}>
        <Route index element={<AddTarget />} />
        <Route
          path={routes.addTargetSpecification}
          element={<AddTargetSpecification />}
        />
      </Route>
      <Route path={routes.addforecast}>
        <Route index element={<AddForecast />} />
        <Route
          path={routes.addForecastSpecification}
          element={<AddForecastSpecification />}
        />
      </Route>
      <Route path={routes.createNewScenario} element={<CreateNewScenario />} />
    </Route>
    {isURLAllowed ? (
      <Route path={routes.viewEngagement} element={<ViewEngagement />} />
    ) : (
      <Route path="*" element={<RedirectToExternal />} />
    )}
    <Route path={routes.powerBI} element={<PowerBI />} />
    <Route
      path={routes.externalUserPowerBI}
      element={<ExternalUserPowerBI />}
    />
    <Route path={routes.decarbProjectsLibrary}>
      <Route index element={<ProjectsLibrary />} />
      <Route
        path={routes.decarbProjectsLibraryDetails}
        element={<ProjectDetails />}
      />
    </Route>{' '}
    :
    {isURLAllowed ? (
      <Route path={routes.decarbProjectsLibraryDetails}>
        <Route index element={<ProjectDetails />} />
      </Route>
    ) : (
      <Route path="*" element={<RedirectToExternal />} /> // Redirect to default URL
    )}
  </Route>
);

export default AppRoutes;
